// extracted by mini-css-extract-plugin
module.exports = {"rich-text-editor":"_3Ek6Gj-d8nJCxcYGYLsRCF"};